import type { GQL_ID } from '@@partner:types:graphql'
import type { Shop, ShopBox, ShopTagInfo, SlotPlanInfo } from '@@partner:types:app'

import type { ShopInfoInput } from '@@partner:graphql/mutation/shop/updateShopInfo.gql'
// import type { Optional } from 'utility-types'

import { mergeLeftDropping } from 'merge-left-utils'
import { ShopTagInfoInput } from '@@partner:graphql/mutation/shopTag/updateShopTagInfo.gql'
import { DEFAULT_LOCALES } from '@@partner:config/locale'


export type ShopTagStateType = Partial<ShopTagInfo> & {
  icon_id?: GQL_ID
  system_name: string
  languages: string[]
}
export const SHOP_TAG_DEFAULT_STATE: ShopTagStateType = {
  id: undefined,
  name: '',
  system_name: '',
  icon_id: undefined,
  sort_order: 0,
  i18n: [],
  languages: DEFAULT_LOCALES,
  icon: {
    url: undefined
  }
}

export const makeDefaultState = (id?: GQL_ID): ShopTagStateType =>
  ({
    ...SHOP_TAG_DEFAULT_STATE,
    id
  })

export const mapStateToApiVariable = (state: ShopTagStateType): ShopTagInfoInput => {
  return mergeLeftDropping(
    [
      'icon',
      'languages'
    ],
    state,
    {
      icon_id: state.icon_id || undefined,
      sort_order: Number(state.sort_order) || 0,
    }
  )
}

export const mapApiDataToState = (data: ShopTagInfo): ShopTagStateType => {
  const result = {
    id: data.id,
    name: data.name,
    system_name: data.system_name,
    icon: data.icon,
    icon_id: data.icon_id,
    sort_order: data.sort_order,
    i18n: data.i18n,
    languages: data.i18n?.length && data.i18n.length > 0 ? data.i18n?.map((i18n) => i18n.language_code) : DEFAULT_LOCALES,
  }

  return result
}
